import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { GetState, Subscribe } from '../state/createState';
import { ControllerProps } from '../controller';
import { WidgetViewModel } from './viewModel';
import { subscribeToAgendaViewModel } from './agendaViewModel/agendaViewModel';
import { subscribeToTimeZoneViewModel } from './timeZoneViewModel/timeZoneViewModel';
import { subscribeToDatePickerViewModel } from './datePickerViewModel/datePickerViewModel';
import { subscribeToInitialLoaderViewModel } from './initialLoaderViewModel/initialLoaderViewModel';
import { subscribeToLoadMoreViewModel } from './loadMoreViewModel/loadMoreViewModel';
import { subscribeToFiltersViewModel } from './filtersViewModel/filtersViewModel';
import { DailyAgendaBiLogger } from '../../../utils/bi/biLogger';
import { subscribeToDialogViewModel } from './dialogViewModel/dialogViewModel';
import { ISettingsParams } from '../settingsParams';
import { DailyAgendaState } from '../state/types';
import { subscribeToTitleViewModel } from './titleViewModel/titleViewModel';

export type SetViewModel = (partialViewModel: Partial<WidgetViewModel>) => void;
export type ViewModelSubscription = (args: {
  subscribe: Subscribe;
  setViewModel: SetViewModel;
  flowAPI: ControllerFlowAPI;
  getState: GetState;
  biLogger: DailyAgendaBiLogger;
}) => void;

export const extractSettingsKeys = (
  state: DailyAgendaState,
  keys: (keyof ISettingsParams)[],
) => {
  return keys.reduce((acc, key) => {
    acc[key] = state.settings[key];
    return acc;
  }, {} as Record<keyof ISettingsParams, any>);
};

export const initViewModelSubscriptions = ({
  flowAPI,
  getState,
  viewModel,
  subscribe,
  setProps,
  biLogger,
}: {
  flowAPI: ControllerFlowAPI;
  getState: GetState;
  viewModel: WidgetViewModel;
  subscribe: Subscribe;
  setProps: (props: ControllerProps) => void;
  biLogger: DailyAgendaBiLogger;
}) => {
  const setViewModel: SetViewModel = (partialViewModel) => {
    Object.assign(viewModel, partialViewModel);
    setProps({ viewModel: { ...viewModel } });
  };

  const args = {
    subscribe,
    setViewModel,
    flowAPI,
    getState,
    biLogger,
  };

  subscribeToInitialLoaderViewModel(args);
  subscribeToAgendaViewModel(args);
  subscribeToTitleViewModel(args);
  subscribeToDialogViewModel(args);
  subscribeToTimeZoneViewModel(args);
  subscribeToDatePickerViewModel(args);
  subscribeToLoadMoreViewModel(args);
  subscribeToFiltersViewModel(args);
};
